import { Component} from "@angular/core";
import { MatDialogRef,  } from "@angular/material/dialog";

@Component({
  selector: 'delete-feedback-dialog-app',
  templateUrl: 'delete-feedback-dialog.component.html',
  styleUrls: ['./delete-feedback-dialog.component.scss'],
})
export class DeleteFeedbackDialogComponent {
  
  constructor(
    private dialogRef: MatDialogRef<DeleteFeedbackDialogComponent>,
    ) {   
      }

  onDeleteFeedBack () {
      this.dialogRef.close('OK');
  }
}